import fetch from "../../api/AxiosAdapter";
import ConfiguracaoAm from "../ConfiguracaoAm";
import { FiltroPesquisaAutotexto } from "../modelo/FiltroPesquisaAutotexto";
import { Autotexto } from "../modelo/Autotexto";
import { AutotextoAgrupado } from "../modelo/AutotextoAgrupado";

class AutotextosApi {

    async recuperarTodos(): Promise<Autotexto[]> {
        const result = await fetch<Autotexto[]>(ConfiguracaoAm.urlAutotextos);
        return result.data;
    }

    async recuperarAgrupados(): Promise<AutotextoAgrupado[]> {
        const result = await fetch<AutotextoAgrupado[]>(ConfiguracaoAm.urlAutotextos + 'modelo');
        return result.data;
    }

    async filtrar(filtro: FiltroPesquisaAutotexto): Promise<Autotexto[]> {
        const result = await fetch<Autotexto[]>(ConfiguracaoAm.urlAutotextos + 'filtrar/',
            {
                method: 'POST',
                body: filtro
            });
        return result.data;
    }

    async salvar(autotexto: Autotexto) {
        const result = await fetch<Autotexto[]>(ConfiguracaoAm.urlAutotextos,
            {
                method: 'POST',
                body: autotexto
            });
        return result.data;
    }

    async atualizar(autotexto: Autotexto) {
        const result = await fetch<Autotexto[]>(ConfiguracaoAm.urlAutotextos,
            {
                method: 'PUT',
                body: autotexto
            });
        return result.data;
    }

    async excluir(autotexto: Autotexto) {
        return fetch<Autotexto[]>(ConfiguracaoAm.urlAutotextos + autotexto.id,
            {
                method: 'DELETE',
                body: autotexto
            });
    }

}

export default new AutotextosApi();
